<template>
    <div>
        <div>
            <fieldset>
                <div class="row">
                    <legend>Student Information</legend>
                </div>
            </fieldset>
        </div>
        <div class="row">
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4 medium-3 "> Name:</div>
                    <div class="columns small-8 medium-9"> {{sampleobject.firstName}} {{sampleobject.lastName}}</div>
                </div>
            </div>
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4 medium-3 "> Student ID: </div>
                    <div class="columns small-8 medium-9"> {{sampleobject.practiceName}}</div>
                </div>
            </div>
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4 medium-3"> Phone: </div>
                    <div class="columns small-8 medium-9"> {{sampleobject.phone}} </div>
                </div>
            </div>
             <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4 medium-3"> Email Address: </div>
                    <div class="columns small-8 medium-9"> {{sampleobject.email}} </div>
                </div>
            </div>
            <div class="column small-12 medium-12" style="margin-top: 20px">
                <div class="row">
                    <div class="columns small-4  medium-3 "> Graduation Year: </div>
                    <div class="columns small-8 medium-9"> {{sampleobject.role}}</div>
                </div>
            </div>
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4 medium-3"> Current Lens: </div>
                    <div class="columns small-8 medium-9"> {{sampleobject.currentLens}} </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
  props: ["sampleobject"],
  methods: {
    validate() {
      this.$validator.validateAll();
    },
    formatShippingPhoneNumber() {
      this.sampleobject.phone = this.formatPhoneNumber(this.sampleobject.phone);
    },
    formatPhoneNumber(args) {
      var s2 = ("" + args).replace(/\D/g, "");
      var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
      return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
    }
  },
  created() {
    this.formatShippingPhoneNumber();
  }
};
</script>
<style>
.frame-review-section {
  margin-top: 15px;
}
</style>
